import { render, staticRenderFns } from "./contract-information-index.vue?vue&type=template&id=22b474a8"
import script from "./contract-information-index.vue?vue&type=script&lang=js"
export * from "./contract-information-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports